module.exports = __webpack_public_path__ + "img/aabana-logo.bdb0071f.svg";